var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('el-dialog', {
    attrs: {
      "title": "Edit Linked Transaction",
      "close-on-click-modal": false,
      "visible": _vm.visible,
      "width": "1460px",
      "top": "3vh"
    },
    on: {
      "update:visible": function updateVisible($event) {
        _vm.visible = $event;
      }
    }
  }, [_c('div', {
    staticClass: "pb20"
  }, [_c('el-button', {
    attrs: {
      "type": "primary",
      "plain": ""
    },
    on: {
      "click": _vm.addLinkedTransaction
    }
  }, [_vm._v("Add")])], 1), _c('div', {
    staticClass: "tableBorder"
  }, [_c('el-form', {
    ref: "dataForm",
    attrs: {
      "model": _vm.dataForm,
      "autocomplete": "off",
      "label-position": "top"
    }
  }, [_c('el-row', {
    staticClass: "customTh",
    attrs: {
      "gutter": 10
    }
  }, [_c('el-col', {
    staticClass: "tac",
    attrs: {
      "span": 3
    }
  }, [_c('span', {
    staticClass: "red"
  }, [_vm._v("*")]), _vm._v(" Transaction No. "), _c('el-popover', {
    attrs: {
      "placement": "bottom",
      "trigger": "hover"
    }
  }, [_c('span', {
    staticClass: "fs12"
  }, [_vm._v("Data Source: \"Operation\" section of this system")]), _c('span', {
    staticClass: "pearl-blue fs16 ml4 el-icon-warning",
    attrs: {
      "slot": "reference"
    },
    slot: "reference"
  })])], 1), _c('el-col', {
    staticClass: "tac",
    attrs: {
      "span": 5
    }
  }, [_vm._v("Supplier")]), _c('el-col', {
    staticClass: "tac",
    attrs: {
      "span": 2
    }
  }, [_vm._v("Currency")]), _c('el-col', {
    staticClass: "tac",
    attrs: {
      "span": 4
    }
  }, [_vm._v("Related Transaction")]), _c('el-col', {
    staticClass: "tac",
    attrs: {
      "span": 4
    }
  }, [_vm._v("Related Turnover")]), _c('el-col', {
    staticClass: "tac",
    attrs: {
      "span": 5
    }
  }, [_c('span', {
    staticClass: "red"
  }, [_vm._v("*")]), _vm._v(" In-charge "), _c('el-popover', {
    attrs: {
      "placement": "bottom",
      "trigger": "hover"
    }
  }, [_c('span', {
    staticClass: "fs12"
  }, [_vm._v("Data Source: \"Settings-User\" section of this system")]), _c('span', {
    staticClass: "pearl-blue fs16 ml4 el-icon-warning",
    attrs: {
      "slot": "reference"
    },
    slot: "reference"
  })])], 1), _c('el-col', {
    staticClass: "tac",
    attrs: {
      "span": 1
    }
  }, [_vm._v("Action")])], 1), _vm._l(_vm.dataForm.dataList, function (parent, index) {
    return _c('div', {
      key: "dataList-".concat(index),
      staticClass: "customTbody"
    }, [_c('el-row', {
      staticClass: "fxRow",
      attrs: {
        "gutter": 10
      }
    }, [_c('el-col', {
      attrs: {
        "span": 3
      }
    }, [_c('el-form-item', {
      ref: "dataList.".concat(index, ".transactionNo"),
      refInFor: true,
      attrs: {
        "prop": "dataList.".concat(index, ".transactionNo"),
        "rules": {
          required: true,
          message: 'please select',
          trigger: 'submit'
        }
      }
    }, [_c('el-select', {
      staticClass: "wdb100",
      attrs: {
        "placeholder": "Transaction No.",
        "clearable": "",
        "filterable": "",
        "remote": "",
        "remote-method": _vm.getTransactionNoRemote,
        "loading": _vm.transactionNoLoading,
        "disabled": _vm.isHasTransactionNo(parent.transactionNo),
        "title": _vm.isHasTransactionNo(parent.transactionNo) ? 'Have been used' : ''
      },
      on: {
        "clear": function clear($event) {
          return _vm.getTransactionNoRemote('');
        },
        "focus": function focus($event) {
          return _vm.getTransactionNoRemote('');
        },
        "change": function change(val) {
          _vm.transactionNoChange(val, parent);
        }
      },
      model: {
        value: parent.transactionNo,
        callback: function callback($$v) {
          _vm.$set(parent, "transactionNo", $$v);
        },
        expression: "parent.transactionNo"
      }
    }, _vm._l(_vm.transactionNoList, function (item, xv) {
      return _c('el-option', {
        key: "transactionNo-".concat(item.transactionNo, "-").concat(xv),
        staticStyle: {
          "height": "auto",
          "padding": "8px 20px"
        },
        attrs: {
          "label": item.transactionNo,
          "value": item.transactionNo,
          "disabled": _vm.isHasSelectedList(item.transactionNo)
        }
      }, [_c('div', [_c('div', {
        staticClass: "lh20"
      }, [_vm._v(_vm._s(item.transactionNo))]), _c('div', {
        staticClass: "flex"
      }, _vm._l(item.companyInfoList, function (ele, idx) {
        return _c('div', {
          key: "option-".concat(xv, "-").concat(idx),
          staticClass: "lh14 fs12 grey mr4"
        }, [_vm._v(" " + _vm._s(idx > 0 ? "/" : "") + " " + _vm._s(ele.uen) + " - " + _vm._s(ele.companyName) + " ")]);
      }), 0)])]);
    }), 1)], 1)], 1), _c('el-col', {
      staticClass: "tac",
      attrs: {
        "span": 5
      }
    }, [_c('el-form-item', [_c('p', {
      staticClass: "lh18 enbr m0"
    }, [_vm._v(_vm._s(parent.supplierName))])])], 1), _c('el-col', {
      attrs: {
        "span": 2
      }
    }, [_c('el-form-item', {
      ref: "dataList.".concat(index, ".currency"),
      refInFor: true,
      attrs: {
        "prop": "dataList.".concat(index, ".currency")
      }
    }, [_c('el-select', {
      attrs: {
        "placeholder": "Currency",
        "clearable": "",
        "filterable": ""
      },
      model: {
        value: parent.currency,
        callback: function callback($$v) {
          _vm.$set(parent, "currency", $$v);
        },
        expression: "parent.currency"
      }
    }, _vm._l(_vm.currencyList, function (item, idx) {
      return _c('el-option', {
        key: "currency-".concat(index, "-").concat(idx),
        attrs: {
          "label": item.currency,
          "value": item.currency
        }
      });
    }), 1)], 1)], 1), _c('el-col', {
      attrs: {
        "span": 4
      }
    }, [_c('el-form-item', {
      ref: "dataList.".concat(index, ".relatedTransaction"),
      refInFor: true,
      attrs: {
        "prop": "dataList.".concat(index, ".relatedTransaction")
      }
    }, [_c('el-input', {
      directives: [{
        name: "minusPoint2",
        rawName: "v-minusPoint2"
      }],
      staticClass: "wdb100",
      attrs: {
        "clearable": "",
        "placeholder": "0.00"
      },
      model: {
        value: parent.relatedTransaction,
        callback: function callback($$v) {
          _vm.$set(parent, "relatedTransaction", $$v);
        },
        expression: "parent.relatedTransaction"
      }
    }, [_c('template', {
      slot: "prefix"
    }, [_vm._v(_vm._s(_vm.currencySymbolFormat(parent.currency)))])], 2)], 1)], 1), _c('el-col', {
      attrs: {
        "span": 4
      }
    }, [_c('el-form-item', {
      ref: "dataList.".concat(index, ".relatedTurnover"),
      refInFor: true,
      attrs: {
        "prop": "dataList.".concat(index, ".relatedTurnover")
      }
    }, [_c('el-input', {
      directives: [{
        name: "minusPoint2",
        rawName: "v-minusPoint2"
      }],
      staticClass: "wdb100",
      attrs: {
        "clearable": "",
        "placeholder": "0.00"
      },
      model: {
        value: parent.relatedTurnover,
        callback: function callback($$v) {
          _vm.$set(parent, "relatedTurnover", $$v);
        },
        expression: "parent.relatedTurnover"
      }
    }, [_c('template', {
      slot: "prefix"
    }, [_vm._v(_vm._s(_vm.currencySymbolFormat(parent.currency)))])], 2)], 1)], 1), _c('el-col', {
      attrs: {
        "span": 5
      }
    }, [_c('el-form-item', {
      ref: "dataList.".concat(index, ".inChargeUserIds"),
      refInFor: true,
      attrs: {
        "prop": "dataList.".concat(index, ".inChargeUserIds"),
        "rules": {
          type: 'array',
          required: true,
          message: 'please select',
          trigger: 'submit'
        }
      }
    }, [_c('el-select', {
      staticClass: "wdb100",
      attrs: {
        "clearable": "",
        "filterable": "",
        "multiple": "",
        "placeholder": "In-charge"
      },
      model: {
        value: parent.inChargeUserIds,
        callback: function callback($$v) {
          _vm.$set(parent, "inChargeUserIds", $$v);
        },
        expression: "parent.inChargeUserIds"
      }
    }, _vm._l(_vm.inChargeList, function (item, idx) {
      return _c('el-option', {
        key: "inCharge-".concat(index, "-").concat(idx),
        attrs: {
          "label": "".concat(item.nickname, "-").concat(item.staffNo, "-").concat(item.position),
          "value": item.id
        }
      });
    }), 1)], 1)], 1), _c('el-col', {
      staticClass: "tac",
      attrs: {
        "span": 1
      }
    }, [_c('el-form-item', [!_vm.isHasTransactionNo(parent.transactionNo) ? _c('span', {
      staticClass: "fs14 crp red",
      on: {
        "click": function click($event) {
          return _vm.dataForm.dataList.splice(index, 1);
        }
      }
    }, [_vm._v("Delete")]) : _vm._e()])], 1)], 1)], 1);
  })], 2)], 1), _c('span', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    on: {
      "click": function click($event) {
        _vm.visible = false;
      }
    }
  }, [_vm._v("Cancel")]), _c('el-button', {
    attrs: {
      "type": "primary",
      "loading": _vm.submitLoading
    },
    on: {
      "click": _vm.dataFormSubmit
    }
  }, [_vm._v("Save")])], 1)]);
}
var staticRenderFns = []

export { render, staticRenderFns }